import React, { useState, useEffect } from 'react'
import { Box, Grid, Button, Card, Chip, Typography, Avatar, TextField, Divider } from '@mui/material'
import PhotoComponent from '../PhotoComponent';

const SinglePostPhoto = ({ feedPostData }) => {
  const isXsScreen = window.innerWidth < 370;
  const album = feedPostData?.album?.images || feedPostData?.album?.carouselItems?.map(v => { v.url = v.carouselItem;; return v; }) || [];
  const formattedAlbum = Array.isArray(album)
    ? album.map(imageUrl => ({ url: imageUrl?.carouselItem || imageUrl?.image }))
    : [];
  return (
    <Box sx={{ my: 1 }} className="text-center">
      {feedPostData?.album?.carouselItems?.length > 1 ? (
        <Box sx={{ borderRadius: '2rem' }}>
          <PhotoComponent
            width={isXsScreen ? '100%' : '100%'}
            height={isXsScreen ? '100vh' : '100vh'} images={formattedAlbum} bgColor='#FFFFFF' />
        </Box>
      ) : feedPostData?.album?.carouselItems?.length === 1 ? (
        <Box>
          <PhotoComponent
            width={isXsScreen ? '100%' : '100%'}
            height={isXsScreen ? '100vh' : '100vh'} images={[{ url: feedPostData?.album?.carouselItems?.[0]?.carouselItem }]} bgColor='#FFFFFF' />
        </Box>
      ) : feedPostData?.album?.images.length > 1 ? (
        <Box sx={{ borderRadius: '2rem' }}>
          <PhotoComponent
            width={isXsScreen ? '100%' : '100%'}
            height={isXsScreen ? '100vh' : '100vh'} images={formattedAlbum} bgColor='#FFFFFF' />
        </Box>
      ) : feedPostData?.album?.images.length === 1 ? (
        <Box>
          <PhotoComponent
            width={isXsScreen ? '100%' : '100%'}
            height={isXsScreen ? '100vh' : '100vh'} images={[{ url: feedPostData?.album?.images[0]?.image }]} bgColor='#FFFFFF' />
        </Box>
      ) : feedPostData?.image ? (
        <Box>
          <PhotoComponent
            width={isXsScreen ? '100%' : '100%'}
            height={isXsScreen ? '100vh' : '100vh'} images={[{ url: feedPostData.image }]} bgColor='#FFFFFF' />
        </Box>
      ) : null}
    </Box>
  )
}

export default SinglePostPhoto